import { useState, useEffect } from "react";
import { Box, Card, Grid, Typography } from "@mui/material"
import {ButtonBasic, CardItemServicioAdicional} from "../../../components";
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { connect } from "react-redux";
import ContactosAction from '../../../store/actions/contactos';
import { showModal } from "react-redux-modal-provider";
import ModalServiciosSoftland from "../../../modals/softland/ModalServiciosSoftland";
import ConfirmationDialog from "../../../modals/default/ConfirmationDialog";
import AddIcon from '@mui/icons-material/Add';
import SpeedIcon from '@mui/icons-material/Speed';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { v4 as uuidv4 } from 'uuid';

const FormPaso3Screen = ({
  contacto,
  contrato,
  nextStep,
  previousStep,
  iniciarContrato,
}) => {

  const [mbBajada, setmbBajada] = useState(0)
  const [tipoServicio, setTipoServicio] = useState('MAS');
  const [precioFormateado, setPrecioFormateado] = useState(0);

  const [arrSAI, setArrSAI] = useState([{
    "id": uuidv4(),
    "tipo_descripcion": "SERVICOS ASOCIADOS A  LA INSTALACION",
    "nombre": "Bonificacion Adhesión a débito automático VISA - MAS",
    "nombre_s": "Bonificacion Adhesión a débito automático VISA - MAS",
    "importe_s": "-24.800000",
    "moneda_s": "USD",
    "cantidad_s": "0.1000",
    "tipoServicio_s": "SAI   ",
    "id_s": 10,
    "servicioIdSoftland_ds": "1010",
    "anchoBajada_s": "",
    "anchoSubida_s": "",
    "tipoAnchoBajada_s": "",
    "tipoAnchoSubida_s": "",
    "obs_s": "-",
    "cantMeses_ds": 12,
    "vigencia_ds": "S",
    "nivelBonificacion": "bonificacion_nivel1"
  }])
  const openModalCreated = () =>{
    showModal(ModalServiciosSoftland,{serviciosAdd:arrSAI,setAdd: setArrSAI,precioPlan: contrato?.precio,tipoServicio: tipoServicio});
  }
  const openModalEdit = (item) =>{
      showModal(ModalServiciosSoftland,{add:item, serviciosAdd:arrSAI, setAdd: setArrSAI, precioPlan: contrato?.precio, tipoServicio: tipoServicio});
  }
  const onEliminar = (itemSer) => {
    showModal(ConfirmationDialog, {
        title: 'Eliminar el Servicio Seleccionado',
        message: '¿Esta seguro que desea eliminar el Servicio Seleccionado?',
        onConfirm: () => {
            const filtro = arrSAI.filter((serv)=> serv.id !== itemSer.id)
            setArrSAI(filtro)
        }
    });
  };

  useEffect(() => {
    if(contrato?.servicios?.length > 0){
      const splite = contrato?.servicios[0]?.anchoBajada_s?.split('.')
      if(splite?.length > 0){
          setmbBajada(splite[0])
      }
      
      // Formatear el precio
      if(contrato?.servicios[0]?.importe_s){
        const numero = Number(contrato?.servicios[0]?.importe_s)
        if(!isNaN(numero)){
          setPrecioFormateado(Math.round(numero * 100) / 100)
        }
      }
    }
    if(contrato?.precio && arrSAI?.length > 0){
      const copiaArr = arrSAI;
      copiaArr.forEach((e)=>{
        e.importe_s = ((contrato?.precio || 0) * -1).toFixed(6)
      })
      setArrSAI(copiaArr)
    }
}, [contrato])
  const onSubmit = () => {
    let form = contrato?.servicios;
    let requiereAutorizacion = 'NO';
    if(arrSAI?.length > 0){
      const arrPrincipal = [contrato?.servicios[0]]
      form = arrPrincipal?.concat(arrSAI);
      arrSAI?.forEach((dat)=>{
        if(dat?.nivelBonificacion === 'bonificacion_nivel2' || dat?.nivelBonificacion === 'bonificacion_nivel3'){
          requiereAutorizacion = 'SI'
        }
      })
    }else{
      form = contrato?.servicios?.filter((e)=> !e?.id) || [];
    }

    iniciarContrato({
        ...contrato,
        servicios: form,
        requiereAutorizacion: requiereAutorizacion
    })
    nextStep();
  };

  useEffect(() => {
    if(contacto?.categoria_cxe){
        let categoria = '';
        switch (contacto?.categoria_cxe) {
            case 'PYM':
            case 'PYMIN':
                categoria= 'PYM'
                break;
            case 'MAS':
            case 'MASIN':
                categoria= 'MAS'
                break;
            default:
                break;
        }
        setTipoServicio(categoria)
    }
  }, [contacto])

  return (
    <Box sx={{overflow: 'overlay',height: '76vh'}} className='side'>
      <Grid container mt={2}>
        <Grid xs={12} lg={4.9}>
          <Card sx={{background: '#fff !important', cursor: 'pointer'}}>
            <Grid container>
              <Grid item xs={12} p={1}>
                <Typography sx={{color: '#000', fontWeight: 'bold'}}>Plan seleccionado</Typography>
              </Grid>
              {contrato?.servicios?.length > 0 && (
                <Grid item xs={12} p={2}>
                  <Card 
                    sx={{
                      background: contrato?.tipoConSoft_t === 'NPYME' 
                        ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                        : 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)',
                      p: 2.5,
                      borderRadius: 3,
                      position: 'relative',
                      overflow: 'hidden',
                      boxShadow: contrato?.tipoConSoft_t === 'NPYME'
                        ? '0 8px 24px rgba(255, 159, 67, 0.3)'
                        : '0 8px 24px rgba(30, 136, 229, 0.3)',
                      transition: 'all 0.3s ease',
                      '&:hover': {
                        transform: 'translateY(-2px)',
                        boxShadow: contrato?.tipoConSoft_t === 'NPYME'
                          ? '0 12px 32px rgba(255, 159, 67, 0.4)'
                          : '0 12px 32px rgba(30, 136, 229, 0.4)'
                      }
                    }}
                  >
                    {/* Barra superior animada */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '4px',
                        background: contrato?.tipoConSoft_t === 'NPYME'
                          ? 'linear-gradient(90deg, #ffb84d 0%, #ffc870 50%, #ffb84d 100%)'
                          : 'linear-gradient(90deg, #42a5f5 0%, #64b5f6 50%, #42a5f5 100%)',
                        backgroundSize: '200% 100%',
                        animation: 'shimmer 2s ease-in-out infinite',
                        '@keyframes shimmer': {
                          '0%': { backgroundPosition: '-200% 0' },
                          '100%': { backgroundPosition: '200% 0' }
                        }
                      }}
                    />

                    {/* Badge de Plan Seleccionado */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 16,
                        right: 16,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5,
                        px: 1.5,
                        py: 0.5,
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '20px',
                        backdropFilter: 'blur(10px)'
                      }}
                    >
                      <CheckCircleIcon sx={{ fontSize: 16, color: '#fff' }} />
                      <Typography
                        sx={{
                          color: '#fff',
                          fontSize: 10,
                          fontWeight: 700,
                          textTransform: 'uppercase',
                          letterSpacing: '0.5px'
                        }}
                      >
                        Seleccionado
                      </Typography>
                    </Box>

                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={7}>
                        {/* Categoría con icono */}
                        <Box display='flex' alignItems='center' gap={1} mb={1}>
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              width: 28,
                              height: 28,
                              borderRadius: '8px',
                              background: 'rgba(255, 255, 255, 0.25)',
                              backdropFilter: 'blur(10px)'
                            }}
                          >
                            <SignalCellularAltIcon sx={{ fontSize: 16, color: '#fff' }} />
                          </Box>
                          <Typography 
                            sx={{
                              color: 'rgba(255, 255, 255, 0.95)',
                              fontSize: 13,
                              fontWeight: 700,
                              letterSpacing: '1px',
                              textTransform: 'uppercase'
                            }}
                          >
                            {contrato?.tipoConSoft_t}
                          </Typography>
                        </Box>

                        {/* Nombre del servicio */}
                        <Typography 
                          sx={{
                            color: '#fff',
                            fontWeight: 800,
                            fontSize: { xs: 18, sm: 20, md: 22 },
                            lineHeight: 1.3,
                            textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)'
                          }}
                        >
                          {contrato?.servicios[0]?.nombre_s}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={5}>
                        <Box display='flex' flexDirection='column' gap={1.5}>
                          {/* Velocidad */}
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              p: 1.5,
                              backgroundColor: 'rgba(255, 255, 255, 0.15)',
                              borderRadius: '12px',
                              border: '2px solid rgba(255, 255, 255, 0.3)',
                              backdropFilter: 'blur(10px)',
                              position: 'relative',
                              overflow: 'hidden'
                            }}
                          >
                            {/* Icono decorativo de fondo */}
                            <SpeedIcon 
                              sx={{
                                position: 'absolute',
                                top: -8,
                                right: -8,
                                fontSize: 50,
                                color: 'rgba(255, 255, 255, 0.1)',
                                transform: 'rotate(15deg)'
                              }}
                            />
                            
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 36,
                                height: 36,
                                borderRadius: '10px',
                                background: 'rgba(255, 255, 255, 0.25)',
                                zIndex: 1
                              }}
                            >
                              <SpeedIcon sx={{ fontSize: 20, color: '#fff' }} />
                            </Box>
                            
                            <Box sx={{ zIndex: 1 }}>
                              <Typography 
                                sx={{
                                  color: 'rgba(255, 255, 255, 0.85)',
                                  fontSize: 10,
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.8px'
                                }}
                              >
                                Velocidad
                              </Typography>
                              <Box display='flex' alignItems='baseline' gap={0.5}>
                                <Typography 
                                  sx={{
                                    color: '#fff',
                                    fontWeight: 800,
                                    fontSize: 24,
                                    lineHeight: 1
                                  }}
                                >
                                  {mbBajada}
                                </Typography>
                                <Typography 
                                  sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    fontSize: 14,
                                    fontWeight: 600
                                  }}
                                >
                                  Mb
                                </Typography>
                              </Box>
                            </Box>
                          </Box>

                          {/* Precio */}
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: 1.5,
                              p: 1.5,
                              background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.15) 100%)',
                              borderRadius: '12px',
                              border: '2px solid rgba(255, 255, 255, 0.3)',
                              backdropFilter: 'blur(10px)',
                              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                              position: 'relative',
                              overflow: 'hidden'
                            }}
                          >
                            {/* Icono decorativo de fondo */}
                            <AttachMoneyIcon 
                              sx={{
                                position: 'absolute',
                                top: -8,
                                right: -8,
                                fontSize: 50,
                                color: 'rgba(255, 255, 255, 0.1)',
                                transform: 'rotate(-15deg)'
                              }}
                            />
                            
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: 36,
                                height: 36,
                                borderRadius: '10px',
                                background: 'rgba(255, 255, 255, 0.25)',
                                zIndex: 1
                              }}
                            >
                              <AttachMoneyIcon sx={{ fontSize: 20, color: '#fff' }} />
                            </Box>
                            
                            <Box sx={{ zIndex: 1 }}>
                              <Typography 
                                sx={{
                                  color: 'rgba(255, 255, 255, 0.85)',
                                  fontSize: 10,
                                  fontWeight: 600,
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.8px'
                                }}
                              >
                                Precio
                              </Typography>
                              <Box display='flex' alignItems='baseline' gap={0.3}>
                                <Typography 
                                  sx={{
                                    color: '#fff',
                                    fontSize: 14,
                                    fontWeight: 700
                                  }}
                                >
                                  $
                                </Typography>
                                <Typography 
                                  sx={{
                                    color: '#fff',
                                    fontWeight: 800,
                                    fontSize: 24,
                                    lineHeight: 1
                                  }}
                                >
                                  {precioFormateado}
                                </Typography>
                                <Typography 
                                  sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    fontSize: 12,
                                    fontWeight: 500
                                  }}
                                >
                                  /mes
                                </Typography>
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              )}
            </Grid>
          </Card>
        </Grid>
        <Grid xs={12} lg={6.9} ml={1}>
          <Card sx={{background: '#fff !important'}}>
            <Box p={2}>
              <Box sx={{display: 'flex', justifyContent:'space-between'}}>
                <Typography sx={{color: '#15294b', fontWeight: 'bold'}} variant='h5'>
                  Listado de servicios agregados al plan
                </Typography>
                <ButtonBasic
                  textButton="Agregar items"
                  iconStart={<AddIcon sx={{color: '#0364ff'}} />}
                  variant="wk"
                  color='nextWhite'
                  sx={{fontWeight: 'bold', border:1,borderColor: '#0364ff'}}
                  onClick={()=>openModalCreated()}
                />
              </Box>
              {arrSAI?.length > 0 ?(
                <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                  {arrSAI.map((sai)=>(
                    <CardItemServicioAdicional
                      key={sai?.id}
                      item={sai}
                      precioPlan={contrato?.precio}
                      onEliminar={onEliminar}
                      openModalEdit={openModalEdit}
                    />
                  ))}
                </Box>
              ):(
                <Box display='flex' justifyContent='center' alignItems='center' flexDirection='column' mb={15}>
                  <img src="/img/carritoCompra.png" style={{width: 220, height: 220}} />
                  <Typography sx={{color: '#6b788e', fontWeight: 'bold',marginTop: 2}} variant='h5'>Aún no se agrego ningun servicio adicional</Typography>
                </Box>
              )}
            </Box>
          </Card>
        </Grid>
      </Grid>
      <Box pr={3} display='flex' justifyContent='end' marginBottom={15} marginTop={2}>
        <ButtonBasic
          textButton='Volver'
          iconStart={<ArrowBackOutlinedIcon />}
          onClick={()=>previousStep()}
          variant='wk'
          color='prevStep'
        />
        <ButtonBasic
          textButton='Continuar'
          iconEnd={<ArrowForwardIcon />}
          onClick={()=>onSubmit()}
          variant='wk'
          color='nextStep'
          isDisabled={contrato?.servicios?.length <= 0}
        />
      </Box>
    </Box>
  )
}
const mapStateToProps = (state) => ({
  contacto: state.contactos.current,
  contrato: state.contactos.contrato
});

const mapDispatchToProps = (dispatch) => ({
  iniciarContrato: (data) => dispatch(ContactosAction.iniciarContrato(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(FormPaso3Screen);